import React, { useEffect, useState } from 'react';
import {
  Box, Table, Thead, Tbody, Tr, Th, Td, Text, Spinner, Flex,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Icon
} from '@chakra-ui/react';
import Pagination from 'react-js-pagination';
import { LuMoreVertical, LuPencil } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';


const BillingTable = ({ search, status, invoices, loading, activePage, totalItems, setActivePage, itemsPerPage }) => {
  const navigate = useNavigate()
  const handleEdit = (id) => {
    navigate(`/billing-details/${id}`)
  }
  return (
    <Box>
      {loading ? (
        <Flex justify="center" py={10}>
          <Spinner color="blue.500" size="lg" />
        </Flex>
      ) : invoices.length === 0 ? (
        <Text textAlign="center" py={6} color="gray.600">No invoices found.</Text>
      ) : (
        <>
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead bg="gray.50">
                <Tr>
                  <Th>Invoice #</Th>
                  <Th>Customer</Th>
                  <Th>Billing Period</Th>
                  <Th>Due Date</Th>
                  <Th>Status</Th>
                  <Th isNumeric>Total (PKR)</Th>
                  <Th ></Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice) => (
                  <Tr key={invoice.invoice_id}>
                    <Td>{invoice.invoice}</Td>
                    <Td>{invoice.customer}</Td>
                    <Td>{invoice.billingPeriod}</Td>
                    <Td>{invoice.dueDate}</Td>
                    <Td>{invoice.status}</Td>
                    <Td isNumeric>Rs {Number(invoice.grandTotalPKR).toFixed(2)}</Td>
                    <Td>
                      <Flex alignItems={"end"} justifyContent={"end"}>
                      <Menu>
                        <MenuButton as={IconButton} icon={<LuMoreVertical />} size="sm" variant="ghost" />
                        <MenuList>
                          <MenuItem icon={<Icon as={LuPencil} />} onClick={() => handleEdit(invoice.invoice_id)}>View Invoice</MenuItem>

                        </MenuList>
                      </Menu>
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>

          {/* Pagination */}
          <Box mt={8} display="flex" justifyContent="center">
            <Pagination
              activePage={activePage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={totalItems}
              pageRangeDisplayed={5}
              onChange={(pageNumber) => setActivePage(pageNumber)}
              itemClass="pagination-item"
              linkClass="pagination-link"
              activeClass="active-page"
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default BillingTable;
